export default __webpack_public_path__ + "static/media/imgEventCongratsItem.3de96245.png";